<div class="mobile-app-header-container" [class.impersonation]="model.impersonation$()">
  <div class="activation-button-container" (click)="activateMenu()">
    <img src="./assets/icons/menu/mobile-menu-button.png" />
  </div>

  <div class="logo-container">
    <div class="logo-icon">
      <img src="./assets/img/logos/see-circle-logo.png" />
    </div>
    <div class="logo-title">
      <img src="./assets/img/logos/see-title-logo.png" />
    </div>
  </div>
</div>
